import React, { useState } from "react";
import { useCheckAccess } from "../../utils/Utilities";
import { runOneTimeAdminExecution } from "../../service/AdminApi";

function OneTimeExecution() {
  useCheckAccess("SuperUser");

  const [loading, setLoading] = useState(false);
  const [batchResults, setBatchResults] = useState([]);
  const [error, setError] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleConfirmSend = async () => {
    setShowConfirmModal(false);
    await proceedWithOneTimeExecution();
  };

  const startOneTimeExecution = async () => {

    setShowConfirmModal(true);

  };

  const proceedWithOneTimeExecution = async () => {
    setLoading(true);
    setBatchResults([]);
    setError(null);

    try {
      const response = await runOneTimeAdminExecution(JSON.stringify({ }));

      if (!response.ok) {
        throw new Error("Failed to trigger one time execution");
      }

      const data = await response.json();

      setBatchResults([
        {
          batch: "All",
          successCount: "-",
          failedCount: "-",
          message: data.message,
        },
      ]);
    } catch (err) {
      setError(err.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>


      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <br />
            <h3>One Time Execution</h3>
            <br />

            <button
              type="button"
              className="auth_submit"
              disabled={loading}
              onClick={startOneTimeExecution}
            >
              {loading ? "அனுப்புகிறது..." : "Request One Time execution"}
            </button>

            <br />
            <br />

            {error && <div className="auth_error">❗ {error}</div>}

          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              width: "90%",
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            <h3>உறுதிப்படுத்தல் தேவை</h3>
            <p>
              இது <strong>உண்மையான பயனர்கள்</strong> ஆகும்.<br />
             தொடர விரும்புகிறீர்களா?
            </p>
            <div style={{ marginTop: "20px" }}>
              <button
                onClick={handleConfirmSend}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  border: "none",
                  marginRight: "10px",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                ஆம், அனுப்பு
              </button>
              <button
                onClick={() => setShowConfirmModal(false)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#ccc",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                இல்லை, ரத்து செய்
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default OneTimeExecution;
